import React from 'react';
import { TransformCTA } from '../TransformCTA';
import { painPoints } from '../../data/content';
export function PainPoints() {
  return <section className="w-full bg-ink-900 px-5 py-14 sm:py-20" data-id="element-188" data-mp="1twgsyk0u7w5y">
      <div className="mx-auto w-full max-w-xl lg:max-w-5xl" data-id="element-189" data-mp="27mkaixorv1p2">
        <h2 className="text-center font-display text-[26px] font-bold leading-tight text-white sm:text-[34px]" data-id="element-190" data-mp="27o59r0m178t9">
          Do you recognize yourself in any of these situations?
        </h2>
        <p className="mt-4 text-center text-[15px] leading-relaxed text-white/55 sm:text-base" data-id="element-191" data-mp="2hmky4vtoc3z2">
          If you answer “yes” to even one, this Route was created for you.
        </p>

        <ul className="mt-10 grid gap-4 lg:grid-cols-3 lg:gap-5" data-id="element-192" data-mp="2qkdf04f1njok">
          {painPoints.map(point => <li key={point.text} className="flex gap-4 rounded-2xl border border-white/10 bg-white/[0.04] p-5 lg:flex-col lg:gap-3" data-id="element-193" data-mp="2mhgs41ih11et">
              <span className="text-2xl leading-none" aria-hidden="true" data-id="element-194" data-mp="s6v8qkkibpgo">
                {point.emoji}
              </span>
              <p className="text-[14px] leading-relaxed text-white/75 sm:text-[15px]" data-id="element-195" data-mp="1n5qmuz1f4fvt">
                {point.text}
              </p>
            </li>)}
        </ul>

        <div className="mt-12 rounded-2xl border border-teal-500/25 bg-teal-500/[0.07] p-6 text-center" data-id="element-196" data-mp="1x57sjggo6trs">
          <p className="font-display text-[21px] font-bold leading-snug text-white sm:text-[26px]" data-id="element-197" data-mp="21yalbmdmhz6x">
            You don’t need to study more information.
          </p>
          <p className="mt-2 text-[15px] leading-relaxed text-teal-300 sm:text-base" data-id="element-198" data-mp="2awmkicsk25az">
            You need a clinical route that turns evidence into clear decisions.
          </p>
        </div>

        <TransformCTA headline="Turn scattered evidence into clear clinical decisions." data-id="element-199" data-mp="2kvty9137c1ym" />
      </div>
    </section>;
}